<template>
  <div class="bar-wrapper">
    <p class="tips" v-text="tips" v-show="tips" :style="{ left: left + 'px' }"></p>
    <div class="bar" @click="onClick" @mousemove="onMousemove" @mouseout="onMouseout">
      <span
        :style="{
          width: per + '%',
          background: color
        }"
      ></span>
      <!-- <span
        v-if="typeof max === 'number'"
        v-for="n in max" :key="n"
        v-bind:class="{ unfill: n > Number(value) }"
        @click.prevent="$emit('click', n)"
        :style="{ background: color }"
      ></span> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tips: null,
      left: 0
    }
  },
  props: {
    value: Number,
    max: Number,
    colors: Object
  },
  methods: {
    onClick(e) {
      const { currentTarget, clientX } = e
      const { width, left } = currentTarget.getBoundingClientRect()
      const per = (clientX - left) / width
      this.$emit('change', Math.round(this.$props.max * per))
    },
    onMousemove(e) {
      const { max } = this.$props
      const { currentTarget, clientX } = e
      const { width, left } = currentTarget.getBoundingClientRect()
      const per = (clientX - left) / width
      this.$data.left = clientX - left
      this.$data.tips = Math.round(this.$props.max * per)
      clearTimeout(this.timer)
      this.timer = setTimeout(() => this.onMouseout(), 1500)
    },
    onMouseout() {
      this.$data.tips = null
    }
  },
  computed: {
    per() {
      const { value, max } = this.$props
      return Number(value) / Number(max) * 100
    },
    color() {
      const { value, max, colors } = this.$props
      const defaultColor = '#000'
      if (!colors) {
        return defaultColor
      }
      if (value/max <= 0.1) {
        return colors['u10'] || colors['u50'] || colors['u80'] || defaultColor
      }
      if (value/max <= 0.5) {
        return colors['u50'] || colors['u80'] || defaultColor
      }
      if (value/max <= 0.8) {
        return colors['u80'] || defaultColor
      }
      return defaultColor
    }
  }
}
</script>
<style scoped>
.bar-wrapper {
  position: relative;
}
.bar-wrapper .tips {
  margin-bottom: 5px;
  padding: 2px 4px;
  border-radius: 2px;
  position: absolute;
  bottom: 100%;
  left: 0;
  transform: translateX(-50%);
  background: #111;
  color: #ccc;
  font-size: 10px;
  z-index: 1;
}
.bar-wrapper .tips::after {
  content: "";
  display: block;
  transform: translateX(-50%) rotate(45deg);
  width: 8px;
  height: 8px;
  background: #111;
  position: absolute;
  bottom: -3px;
  left: 50%;
}
.bar {
  border-radius: 5px;
  position: relative;
  /* display: flex; */
  height: 6px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.2);
}
.bar span {
  position: relative;
  display: block;
  flex: 1;
  height: 100%;
  background: #;
  /* background: #eee; */
}
/*.bar span::after {
  content: "";
  display: block;
  width: 1px;
  height: 2px;
  background: #ccc;
  position: absolute;
  right: 0;
}*/
/* .bar span.unfill {
  background: #eee !important;
} */
/* .bar::after {
  content: "";
  border-radius: 5px;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 6px;
  background: #ccc;
} */
.bar .value {
  border-radius: 5px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: block;
  height: 100%;
  background: #112;
}
</style>